import React from "react";
import DefectRouter from './Defect/Router';
export { getFields } from './Defect/Router';

export default function DefectSupplierRouter(props){
    return <DefectRouter {...props} mode='SUPPLIER' />;
}